export const MessageDataModel = {
  title: "",
  content: "",
  background_color: "",
  text_color: "",
  start_date: "",
  end_date: "",
  active: ""
}